export const scrolledToBottom = elem => {
  if (!elem) return (window.innerHeight + window.scrollY) >= document.body.scrollHeight - 500;

  return elem.scrollTop >= elem.scrollHeight - elem.offsetHeight - 400;
}